<script>
    export let id = '';
    export let name = '';
    export let label = '';
    export let checked = false;
    export let value = '';
    export let color = 'blue';
    export let className = '';
    export let disabled = false;
    export let changeHandler = () => {};
</script>

<div class="radio-input-container {className}">
    <label for={id} class="radio-label">
        <div class="radio-wrapper">
            <input
                type="radio"
                class={color}
                {name}
                {id}
                {checked}
                on:change={changeHandler}
                {value}
                {disabled}
            />
            <div class="label-text">{@html label}</div>
        </div>
    </label>
</div>

<style>
    .radio-input-container {
        margin: 1.2rem 0;
    }

    .radio-label {
        font-size: 15px;
        display: block;
    }

    .radio-wrapper {
        display: flex;
        align-items: center;
    }

    .label-text {
        flex: 1;
    }

    .radio-input-container input[type='radio'] {
        margin-right: 0.5rem;
        flex-shrink: 0;
        appearance: none;
        height: 1.5rem;
        width: 1.5rem;
        outline: none;
        border-radius: 100%;
        border: 1px solid;
        position: relative;
        cursor: pointer;

        &.blue {
            border-color: #00b0ac;
        }

        &.pink {
            border-color: #d31772;
        }
    }

    .radio-input-container input[type='radio']:before {
        content: '';
        display: block;
        width: 1rem;
        height: 1rem;
        border-radius: 100%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .radio-input-container input[type='radio'].blue:checked::before {
        background: #00b0ac;
    }

    .radio-input-container input[type='radio'].pink:checked::before {
        background: #d31772;
    }

    .radio-input-container input[type='radio']:disabled {
        cursor: not-allowed;
        opacity: 0.5;
    }
</style>
